<template>
  <ul :class="{'disabled': disabled}" class="evaluate-wrap">
    <li v-for="(starType, index) in itemClasses" :key="'evaluate-' + index" :class="$_getStarClass(starType)" class="evaluate-star" @click="$_onClick(index)">
      <t-icon :size="size" :style="$_getStarStyle(starType)" icon="star"></t-icon>
      <t-icon v-if="starType === 'half'" :size="size" :style="$_getHalfStarStyle()" class="star-half" icon="star"></t-icon>
    </li>
  </ul>
</template>
<script>
const ON = 'on'
const OFF = 'off'
const HALF = 'half'
export default {
  name: 'TEvaluate',
  props: {
    colorClass: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    // totalStar: {
    //   type:  [ Number, String ],
    //   default: 5
    // },
    score: {
      type: [ Number, String ],
      default: 0,
      validator: function (value) {
        // 这个值必须匹配下列字符串中的一个
        return value >= 0 && value <= 5
      }
    },
    // half: Boolean,
    size: {
      type: [ Number, String ],
      default: 20
    },
    disabled: Boolean
  },
  data() {
    return {
      totalStar: 5,
      localScore: this.score,
      itemClasses: []
    }
  },
  watch: {
    score(val) {
      this.localScore = val
      this.setClass()
    }
  },
  mounted() {
    this.setClass()
  },
  methods: {
    setClass() {
      let result = []
      // 四舍五入计算把分数换算成0.5的倍数
      let score = Math.floor(this.localScore * 2) / 2
      let intNum = Math.floor(score)
      // 是否需要半星
      let hasDecimal = this.localScore % 1 !== 0
      // 全星push到数组里面
      for (let i = 0; i < intNum; i++) {
        result.push(ON)
      }
      // 半星放到数组里面
      if (hasDecimal) {
        result.push(HALF)
      }
      // 灰色星星放到数组里面
      while (result.length < this.totalStar) {
        result.push(OFF)
      }
      this.itemClasses = result
    },
    // $_getStarType(type) {
    //   return type === 'half' ? 'star-half' : 'star'
    // },
    $_getStarClass(type) {
      let classes = [type]
      return classes.concat(this.colorClass)
    },
    $_getStarStyle(type) {
      if (type === 'on') {
        return {
          color: this.color
        }
      } else {
        return ''
      }
    },
    $_getHalfStarStyle() {
      return {
        color: this.color
      }
    },
    $_onClick(index) {
      if (this.disabled === true) {
        return
      }
      if (this.itemClasses[index] && this.itemClasses[index] === 'on') {
        if (this.localScore > index + 1) {
          this.localScore = index + 1
        } else {
          this.localScore = 0
        }
      } else {
        this.localScore = index + 1
      }
      this.$emit('update:score', this.localScore)
      this.$emit('change', this.localScore)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/evaluate/evaluate.vue